<template>
  <div class="TheLogin-container">
    <div class="my-mask"></div>
    <div class="my-wrap">
      <i
        v-if="modeLogin !== 'mx' && !isNewBind"
        class="my-back fa fa-arrow-left"
        aria-hidden="true"
        @click="setModeLogin()"
      ></i>
      <i class="my-close fa fa-times" aria-hidden="true" @click="doClose()"></i>
      <BaseLoginForm
        v-if="modeLogin === 'cg'"
        mode="cg"
        key="1"
        :isNewBind="isNewBind"
        @toggleAgree="toggleAgree"
        @setModeLogin="setModeLogin"
        @login="doLogin"
      />
      <WxLogin v-if="modeLogin === 'wx'" @login="loginFromWx" />
      <BaseLoginForm
        v-show="modeLogin === 'mx'"
        :defaultIdx="defaultIdx"
        mode="mx"
        key="2"
        @toggleAgree="toggleAgree"
        @setModeLogin="setModeLogin"
        @login="doLogin"
      />
      <BaseSetPsw v-if="isShowSetPsw" @success="vx_toggleLogin(false)" />
    </div>
    <div v-if="isShowAgree" class="my-agree">
      <i class="my-close fa fa-times" aria-hidden="true" @click="toggleAgree(false)"></i>
      <iframe :src="urlArgree" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import $ from 'jquery'
import { mapState, mapMutations, mapActions } from 'vuex'
import BaseLoginForm from './BaseLoginForm'
import WxLogin from './WxLogin'
import BaseSetPsw from './BaseSetPsw'

export default {
  name: 'TheLogin',
  components: {
    BaseLoginForm,
    BaseSetPsw,
    WxLogin
  },
  props: ['isNewBind'],
  data() {
    return {
      defaultIdx: null,
      modeLogin: this.isNewBind ? 'cg' : 'mx',
      isShowAgree: false,
      isShowSetPsw: false,
      urlArgree: '',
      urlMapArgree: {
        mx: 'https://mx.muccybook.com/#/Service',
        cg: 'https://www.66rpg.com/user/agreement'
      }
    }
  },
  computed: {
    ...mapState([
      'vx_loginDefaultIdx'
    ])
  },
  watch: {
  },
  created() {
    this.init()
  },
  methods: {
    ...mapMutations([
      'vx_setData',
      'vx_setToken',
      'vx_toggleLogin'
    ]),
    ...mapActions([
      'vx_act_findOne'
    ]),
    init() {
      if (this.vx_loginDefaultIdx) {
        this.defaultIdx = this.vx_loginDefaultIdx
        this.vx_setData({
          vx_loginDefaultIdx: null
        })
      }
    },
    toggleAgree(reverse = !this.isShowAgree) {
      this.urlArgree = this.urlMapArgree[this.modeLogin]
      if (reverse && this.modeLogin === 'cg') {
        window.open(this.urlArgree)
        return
      }
      this.isShowAgree = reverse
    },
    setModeLogin(v = 'mx') {
      this.modeLogin = v
    },
    loginSuccess(token, isNew = false) {
      this.vx_setToken(token)
      if (isNew) this.isShowSetPsw = true
      this.vx_act_findOne().then(res => {
        if (res.isOk) {
          !isNew && this.vx_toggleLogin(false)
          this.vx_setData({
            vx_loginTimestamp: new Date() * 1
          })
        } else {
          this.$toast(res.msg || (res.message || {}).title || '获取用户信息失败')
          if (this.mode === 'wx') this.setModeLogin()
        }
      })
    },
    doLogin(ref) {
      let cb = this.loginSuccess
      if (this.modeLogin === 'cg') {
        this.loginFromCg(ref)
        return
      }
      if (ref.activeIdx == 2) {
        this.$api.loginByPsw({
          typeCode: ref.activeAreaCode,
          login_name: ref.formPhone.value,
          password: ref.formPsw.value
        }).then(res => {
          if (res.isOk) {
            cb(res.data.token)
          } else {
            this.$toast((res.message || {}).title || '登录失败')
          }
        })
      } else {
        this.$api.loginByCode({
          typeCode: ref.activeAreaCode,
          mobile: ref.formPhone.value,
          validate_code: ref.formCode.value
        }).then(res => {
          if (res.isOk) {
            cb(res.token, res.isNew)
          } else {
            this.$toast((res.message || {}).title || '登录失败')
          }
        })
      }
    },
    loginFromWx({ code, state }) {
      let cb = this.loginSuccess
      this.$api.wxLoginCallback({
        code,
        state,
        apptype: 'h5',
        platformJs: 'pcweb'
      }).then(res => {
        if (res.isOk) cb(res.data)
        else {
          this.$toast(res.msg || (res.message || {}).title || '微信登录失败')
          this.setModeLogin()
        }
      })
    },
    loginFromCg(ref) {
      let success = res => {
        if (res.status == 1) {
          if (this.isNewBind) {
            this.$emit('login', { status: true, data: res.data })
            return
          }
          this.$toast(res.msg || '登录成功');
          this.fn_loginByThird(res.data);
        } else {
          this.$toast(res.msg || '登录失败');
        }
      }
      // 账户密码登录
      if (ref.activeIdx == 2) {
        let _inputAccout = ref.encodeUnicode(ref.formUser.value);
        let _curStr = '{"username":"' + _inputAccout + '","pass_word":"' + ref.encodeUnicode(ref.formPsw.value) + '","timestamp":' + parseInt(new Date().getTime() / 1000) + '}';
        console.log("_curStr", _curStr);
        let _accountCode = ref.encryptXor(_curStr, "brv@eeLzXaXdHDdq");
        _accountCode = ref.hexEncode(_accountCode);
        let url = this.$api._ut.getBaseURL_org() + '/interapi/Muxi/V1/LoginSDK/login_get_user_info' + `?auth=${_accountCode}`;
        $.ajax({
          url,
          method: "get",
          timeout: 15000,
          dataType: "jsonp",
          jsonp: 'jsonCallBack',
          success,
          error: e => {
            console.error('账号密码失败', e)
            this.$toast('网络连接失败')
          }
        })
      } else {
        // 验证码登录
        let _codeLogin = ref.encryptXor(JSON.stringify({ "mobile": ref.formPhone.value, "code": ref.formCode.value, "timestamp": parseInt(new Date().getTime() / 1000) }), "brv@eeLzXaXdHDdq");
        _codeLogin = ref.hexEncode(_codeLogin);
        let url = this.$api._ut.getBaseURL_org() + '/interapi/Muxi/V1/LoginSDK/message_login' + `?auth=${_codeLogin}`;
        $.ajax({
          url,
          method: "get",
          timeout: 15000,
          dataType: "jsonp",
          jsonp: 'jsonCallBack',
          success,
          error: e => {
            console.error('验证码登录失败', e)
            this.$toast('网络连接失败')
          }
        })
      }
    },
    // 第三方登录获取token
    fn_loginByThird(data) {
      let cb = this.loginSuccess
      let _params = {
        apptype: '3',
        userInfo: JSON.stringify({
          nickname: data.nickname || '匿名用户',
          sex: data.sex,
          avatar: data.avatar,
          unionid: data.uid,
          type: '4'
        }),
        platUserSource: JSON.stringify({
          plat: '',
          channel: '',
          pack_name: '',
          ver_code: ''
        })
      }
      this.$api.loginByThird(_params).then(res => {
        if (res.isOk) {
          let token = res.data;
          cb(token)
        } else {
          this.$toast(res.msg || '登录失败')
        }
      }).catch(e => {
        console.error('第三方登录失败', e)
        this.$toast('网络连接失败')
      })
    },
    doClose() {
      if (this.isNewBind) this.$emit('close')
      else this.vx_toggleLogin(false)
    }
  }
}
</script>

<style lang="less" scoped>
.TheLogin-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 199;
}

.my-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.my-wrap {
  position: relative;
  top: 50%;
  width: 404px;
  height: 506px;
  margin: 0 auto;
  padding: 0 50px;
  background: #ffffff;
  transform: translateY(-50%);
}

.my-back,
.my-close {
  position: absolute;
  right: 30px;
  top: 20px;
  font-size: 20px;
  color: #808080;
  cursor: pointer;
  z-index: 99;
}

.my-back {
  right: auto;
  left: 20px;
}

.my-agree {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 480px;
  height: 640px;
  background: #fff;
  z-index: 9;
  transform: translate(-50%, -50%);
  iframe {
    width: 100%;
    height: 100%;
  }
}

.my-loginby {
  margin-top: 20px;
  line-height: 30px;
  font-size: 15px;
  color: #808080;
}

.my-loginicon {
  display: inline-block;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 10px;
  cursor: pointer;
}

.my-loginicon_wx {
  background-image: url(~@/assets/loginicon_wx.png);
}

.my-loginicon_cg {
  background-image: url(~@/assets/loginicon_cg.png);
}
</style>
